export interface OrderRequestPaymentFilterModel {
  PaymentId: number;
  State: number;
  Amount: number;
  AddedDateTime: Date;
  StateLastUpdateDatetime: Date;
}
